import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DatabaseIcon, ShieldCheckIcon, ClipboardListIcon, AwardIcon, UsersIcon, BuildingIcon, FileTextIcon, BrainCircuitIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ServicesOverviewPage() {
  return <div className="w-full" data-id="element-2908" data-mp="37335jrz0gtjf">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-2909" data-mp="3332ftb6govx2">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-2910" data-mp="332kew18uttit">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-2911" data-mp="3gtphnc7ir1xd">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-2912" data-mp="3bw5rbdxjqyp2">
              Expert Solutions for Federal Government and Enterprises
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-2913" data-mp="3ltty528ffwnl"></div>
            <p className="text-xl text-nrs-light font-bold mb-4 max-w-2xl mx-auto" data-id="element-2914" data-mp="3rgwh23bu1rdf">
              Three core service lines. One trusted partner. Mission-critical
              results.
            </p>
            <p className="text-lg text-blue-100 mb-10 max-w-3xl mx-auto" data-id="element-2915" data-mp="4c6u1vv3faxv">
              New River Systems delivers specialized ServiceNow governance and
              development, federal identity and access management (ICAM), and
              mission-critical program management services to DoD and federal
              clients.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FOUR CORE SERVICES */}
      <section className="section-white" data-id="element-2916" data-mp="o0z6vudo8jf3">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-2917" data-mp="o2a8ponk3h3k">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2918" data-mp="s0zwmb680h1g">
            {/* Card 1: ServiceNow */}
            <div className="card flex flex-col h-full" data-id="element-2919" data-mp="x2fi24cb8pkd">
              <div className="mb-6" data-id="element-2920" data-mp="11yw4mu3v2vvc">
                <DatabaseIcon className="h-12 w-12 text-nrs-orange" data-id="element-2921" data-mp="1207ar0ks4fpm" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-2922" data-mp="2y3ln3pe2ucyh">
                ServiceNow Governance & Development
              </h3>
              <div className="text-gray-600 mb-6 space-y-2" data-id="element-2923" data-mp="2t1o14neal41u">
                <p data-id="element-2924" data-mp="37top2f36f18y">Complete platform stewardship from strategy to execution</p>
                <p data-id="element-2925" data-mp="331exyvqbrv53">
                  Self-governing development model eliminates vendor conflicts
                </p>
                <p data-id="element-2926" data-mp="3gsa3pz5j1w4g">Secure government cross-domain expertise</p>
                <p data-id="element-2927" data-mp="3cs018wgy1nuc">Federal Agency trusted partner</p>
              </div>
              <div className="mb-8 flex-grow" data-id="element-2928" data-mp="3ctsxrixuerom">
                <h4 className="font-bold text-nrs-navy mb-2" data-id="element-2929" data-mp="3qrrdarnwgu5p">Key Services:</h4>
                <ul className="space-y-2 text-gray-600" data-id="element-2930" data-mp="3lso5x0kg6buk">
                  <li className="flex items-start gap-2" data-id="element-2931" data-mp="3lt7macug8s6h">
                    <span className="text-nrs-orange mt-1" data-id="element-2932" data-mp="1wcoqx2u5ds70">•</span> Governance:
                    Technical policy, data, security/ATO, strategic
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2933" data-mp="6wcn4kvkvurq">
                    <span className="text-nrs-orange mt-1" data-id="element-2934" data-mp="6wusc707xjbs">•</span> Development:
                    ITSM, HRSD, SPM, SecOps, custom apps
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2935" data-mp="3tcgz6g25z90a">
                    <span className="text-nrs-orange mt-1" data-id="element-2936" data-mp="3t9upa9rswhew">•</span> Operations:
                    Platform O&M, support, enhancements
                  </li>
                </ul>
              </div>
              <div className="mt-auto" data-id="element-2937" data-mp="3kdc098moxdnl">
                <Link to="/services/servicenow" className="btn-primary w-full mb-4" data-id="element-2938" data-mp="3pavdc57njkdy">
                  Explore ServiceNow Services
                </Link>
                <p className="text-xs text-center text-gray-500 italic" data-id="element-2939" data-mp="3aewapa3bacg7">
                  Comprehensive governance + development solutions
                </p>
              </div>
            </div>

            {/* Card 2: ICAM */}
            <div className="card flex flex-col h-full" data-id="element-2940" data-mp="1dkt4ysejbul6">
              <div className="mb-6" data-id="element-2941" data-mp="1dk9l365bqw4i">
                <ShieldCheckIcon className="h-12 w-12 text-nrs-orange" data-id="element-2942" data-mp="39nxq5qb1xemr" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-2943" data-mp="39llajjsrngcv">
                Identity & Access Management (ICAM)
              </h3>
              <div className="text-gray-600 mb-6 space-y-2" data-id="element-2944" data-mp="30mq4q8tmw8a3">
                <p data-id="element-2945" data-mp="30pcac2wysdpo">Federal identity and access management for DoD</p>
                <p data-id="element-2946" data-mp="2vndbn6c664z2">Zero Trust Architecture implementation</p>
                <p data-id="element-2947" data-mp="2qplhs6rys8s8">PIV/CAC, SSO, privileged access management</p>
                <p data-id="element-2948" data-mp="2qr6dhzq0lxro">FICAM-compliant, NIST 800-53 aligned solutions</p>
              </div>
              <div className="mb-8 flex-grow" data-id="element-2949" data-mp="2lx25re8xdlpj">
                <h4 className="font-bold text-nrs-navy mb-2" data-id="element-2950" data-mp="2hw8i8lzea8x6">Key Services:</h4>
                <ul className="space-y-2 text-gray-600" data-id="element-2951" data-mp="2cxnhmlg8dn87">
                  <li className="flex items-start gap-2" data-id="element-2952" data-mp="2cz8c6b2jp662">
                    <span className="text-nrs-orange mt-1" data-id="element-2953" data-mp="27z3qm6ms5l8z">•</span> Zero Trust
                    Architecture & identity governance
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2954" data-mp="231kf3ehgvmkq">
                    <span className="text-nrs-orange mt-1" data-id="element-2955" data-mp="1suiv1pg7vdg0">•</span> Platform
                    integration: SailPoint, CyberArk, OKTA
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2956" data-mp="1xwgiywzkawfa">
                    <span className="text-nrs-orange mt-1" data-id="element-2957" data-mp="22v1kczqjvm5b">•</span> Physical +
                    logical access integration (PACS/LACS)
                  </li>
                </ul>
              </div>
              <div className="mt-auto" data-id="element-2958" data-mp="1a6du0pqy26kw">
                <Link to="/services/identity-access-management" className="btn-primary w-full mb-4" data-id="element-2959" data-mp="1a389lnt9fsvi">
                  Explore ICAM Services
                </Link>
                <p className="text-xs text-center text-gray-500 italic" data-id="element-2960" data-mp="1k1o0pqsaf250">
                  Cleared identity engineers
                </p>
              </div>
            </div>

            {/* Card 3: Program Management */}
            <div className="card flex flex-col h-full" data-id="element-2961" data-mp="rch1epl0e8ip">
              <div className="mb-6" data-id="element-2962" data-mp="wcmmto0oqysc">
                <ClipboardListIcon className="h-12 w-12 text-nrs-orange" data-id="element-2963" data-mp="wbjudbnpsoab" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-2964" data-mp="ob5g0t4qzjib">
                Program Management & PMO Services
              </h3>
              <div className="text-gray-600 mb-6 space-y-2" data-id="element-2965" data-mp="y2s0zh6w0wy9">
                <p data-id="element-2966" data-mp="y28le74pmkne">Mission-critical program delivery in secure environments</p>
                <p data-id="element-2967" data-mp="t4q8y6rhhnan">Agile and traditional program management</p>
                <p data-id="element-2968" data-mp="5duknjm8la85">Cleared program managers and Scrum Masters</p>
                <p data-id="element-2969" data-mp="5ecp33j1yur5">PMO establishment and governance framework design</p>
              </div>
              <div className="mb-8 flex-grow" data-id="element-2970" data-mp="gkprog2w6cx">
                <h4 className="font-bold text-nrs-navy mb-2" data-id="element-2971" data-mp="fc0hvnx3ls6o">Key Services:</h4>
                <ul className="space-y-2 text-gray-600" data-id="element-2972" data-mp="f9xnysstrewo">
                  <li className="flex items-start gap-2" data-id="element-2973" data-mp="ace9psw4n24q">
                    <span className="text-nrs-orange mt-1" data-id="element-2974" data-mp="1qr74b6gnpqtr">•</span> Agile
                    program management (Scrum, SAFe)
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2975" data-mp="1lruf4f2bc7o0">
                    <span className="text-nrs-orange mt-1" data-id="element-2976" data-mp="1tbc447ybtpry">•</span> Traditional
                    program management (PMP, schedule, budget)
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2977" data-mp="1y8lqtfubznc3">
                    <span className="text-nrs-orange mt-1" data-id="element-2978" data-mp="1kcic6uvxxnkq">•</span> PMO
                    establishment and operations
                  </li>
                </ul>
              </div>
              <div className="mt-auto" data-id="element-2979" data-mp="2c238sw7dcs00">
                <Link to="/services/program-and-project-management" className="btn-primary w-full mb-4" data-id="element-2980" data-mp="2c34wc05kn6ym">
                  Explore Program Management
                </Link>
                <p className="text-xs text-center text-gray-500 italic" data-id="element-2981" data-mp="238zxouk74r8j">
                  Certified PMP, CSM, SAFe SPC professionals
                </p>
              </div>
            </div>

            {/* Card 4: AI & Intelligent Automation */}
            <div className="card flex flex-col h-full" data-id="element-2982" data-mp="2uze7ael6fhee">
              <div className="mb-6" data-id="element-2983" data-mp="2zsqv4mi17k63">
                <BrainCircuitIcon className="h-12 w-12 text-nrs-orange" data-id="element-2984" data-mp="2zts9p0y9aosk" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-2985" data-mp="2b3e2yzipxv5l">
                AI & Intelligent Automation
              </h3>
              <div className="text-gray-600 mb-6 space-y-2" data-id="element-2986" data-mp="21bhwp16hayqa">
                <p data-id="element-2987" data-mp="21brmannm33vg">
                  Generative AI and intelligent automation solutions leveraging
                  ServiceNow's GenAI platform plus Azure OpenAI and AWS AI
                  services.
                </p>
                <p data-id="element-2988" data-mp="2txt4owwf01x4">
                  Deploy conversational AI, virtual agents, and agentic
                  workflows across IT, HR, and customer service.
                </p>
                <p data-id="element-2989" data-mp="2k04z1bx9ta06">
                  Transform operations with predictive intelligence and
                  autonomous task execution.
                </p>
              </div>
              <div className="mb-8 flex-grow" data-id="element-2990" data-mp="18nvv1ygta462">
                <h4 className="font-bold text-nrs-navy mb-2" data-id="element-2991" data-mp="18kge0q3kul20">Key Services:</h4>
                <ul className="space-y-2 text-gray-600" data-id="element-2992" data-mp="13mevq7dz6prl">
                  <li className="flex items-start gap-2" data-id="element-2993" data-mp="3fbusfl92rar6">
                    <span className="text-nrs-orange mt-1" data-id="element-2994" data-mp="3f98k3jed0r7w">•</span> Now Assist
                    implementation (ITSM, HRSD, CSM)
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2995" data-mp="3p8h9s026zjog">
                    <span className="text-nrs-orange mt-1" data-id="element-2996" data-mp="3tzpkczf9db37">•</span> Virtual
                    Agent development and training
                  </li>
                  <li className="flex items-start gap-2" data-id="element-2997" data-mp="2t4xzt05erci">
                    <span className="text-nrs-orange mt-1" data-id="element-2998" data-mp="6uqio0ixc9x9">•</span> Agentic AI
                    workflow automation
                  </li>
                </ul>
              </div>
              <div className="mt-auto" data-id="element-2999" data-mp="gtfq0zd72bz9">
                <Link to="/services/ai" className="btn-primary w-full mb-4" data-id="element-3000" data-mp="gsedeqgj5hff">
                  Explore AI Services
                </Link>
                <p className="text-xs text-center text-gray-500 italic" data-id="element-3001" data-mp="2dnu176zeuexn">
                  Transforming workflows with intelligence
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST INDICATORS */}
      <section className="section-white border-t border-gray-200" data-id="element-3002" data-mp="2lovg7dr57mvk">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-3003" data-mp="2qn5cjrolstir">
          <h2 className="text-3xl font-bold text-center mb-4" data-id="element-3004" data-mp="2qozxh5zvklmu">
            Why Federal Agencies and Enterprises Trust New River Systems
          </h2>
          <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-12" data-id="element-3005" data-mp="2zmk3es8on63s"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center" data-id="element-3006" data-mp="34m516zc498ex">
            <div className="flex flex-col items-center" data-id="element-3007" data-mp="39dn0liyhr0xs">
              <AwardIcon className="h-12 w-12 text-nrs-orange mb-4" data-id="element-3008" data-mp="39e6k343shxdx" />
              <div className="font-bold text-lg text-nrs-navy" data-id="element-3009" data-mp="3ebgbgpaqoj4e">
                19 Years Federal Experience
              </div>
            </div>
            <div className="flex flex-col items-center" data-id="element-3010" data-mp="3ic8jxgbsejzm">
              <UsersIcon className="h-12 w-12 text-nrs-orange mb-4" data-id="element-3011" data-mp="3ndxxp3qe9bre" />
              <div className="font-bold text-lg text-nrs-navy" data-id="element-3012" data-mp="1bqc9g4pdqqf0">
                Cleared Professional Teams
              </div>
            </div>
            <div className="flex flex-col items-center" data-id="element-3013" data-mp="16pernt8a7ye1">
              <BuildingIcon className="h-12 w-12 text-nrs-orange mb-4" data-id="element-3014" data-mp="12omkd5iz03ke" />
              <div className="font-bold text-lg text-nrs-navy" data-id="element-3015" data-mp="xq1heycc35s9">
                Trusted Federal Agency Partner
              </div>
            </div>
            <div className="flex flex-col items-center" data-id="element-3016" data-mp="1uf0qgfkqsbli">
              <FileTextIcon className="h-12 w-12 text-nrs-orange mb-4" data-id="element-3017" data-mp="1qeyy4x0wcuiw" />
              <div className="font-bold text-lg text-nrs-navy" data-id="element-3018" data-mp="1qgtjudjzsqo1">
                GSA MAS Contract Holder
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-navy" data-id="element-3019" data-mp="1gmt5dl2tm92n">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-3020" data-mp="2e4jhvi4vjvt8">
          <h3 className="text-2xl font-bold mb-8 text-white" data-id="element-3021" data-mp="29duotydjqqrz">
            Ready to Discuss Your Mission-Critical Project?
          </h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3022" data-mp="2sb4nv09lfrex">
            <Link to="/contact-us" className="btn-primary" data-id="element-3023" data-mp="2x966jk33xopv">
              Contact Business Development
            </Link>
            <Link to="/about-us/contract-vehicles" className="btn-secondary border-white text-white hover:bg-white/10 hover:text-white" data-id="element-3024" data-mp="2jgqch8s6p113">
              View Contract Vehicles
            </Link>
          </div>
        </div>
      </section>
    </div>;
}